import { render, staticRenderFns } from "./StandardTemplate.vue?vue&type=template&id=3ebce6a6&scoped=true&"
import script from "./StandardTemplate.vue?vue&type=script&lang=js&"
export * from "./StandardTemplate.vue?vue&type=script&lang=js&"
import style0 from "./StandardTemplate.vue?vue&type=style&index=0&id=3ebce6a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebce6a6",
  null
  
)

export default component.exports